import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import request from '../../utils/request';
import loginIllustration from '../../assets/images/login-illustration.svg';
import './Login.css';

const Login = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const res = await request.post('/admin/login', {
                username: values.username,
                password: values.password,
                account_type: 'wecom',
            });

            if (res.code === 0) {
                message.success('登录成功');
                // 保存 token 和用户信息
                localStorage.setItem('user_token', res.data.user_token);
                localStorage.setItem('user_info', JSON.stringify(res.data.user_info));

                // 跳转到首页
                navigate('/');
            } else {
                message.error(res.message || '登录失败');
            }
        } catch (error) {
            // 错误处理
            console.error('Login failed:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            {/* 左侧品牌区域 */}
            <div className="login-left">
                <div className="login-left-content">
                    {/* 品牌信息 */}
                    <div className="brand-info">
                        <div className="logo-section">
                            <div className="logo-icon">U</div>
                            <h1 className="brand-name">优量</h1>
                        </div>
                        <h2 className="brand-slogan">广告效果追踪与数据分析平台</h2>
                    </div>

                    {/* 插图 */}
                    <div className="illustration-container">
                        <img src={loginIllustration} alt="数据分析" className="login-illustration" />
                    </div>

                    {/* 底部特性 */}
                    <div className="feature-list">
                        <div className="feature-item">
                            <span className="feature-dot"></span>
                            <span>打通广告投放与客户添加的最后一公里</span>
                        </div>
                        <div className="feature-item">
                            <span className="feature-dot"></span>
                            <span>每一次广告花费都清晰可见</span>
                        </div>
                        <div className="feature-item">
                            <span className="feature-dot"></span>
                            <span>每一分广告花费都花得更有价值</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* 右侧登录表单 */}
            <div className="login-right">
                <div className="login-card">
                    <h1 className="login-welcome">欢迎您！</h1>
                    
                    <div className="login-tab">
                        <span className="tab-item active">账号登录</span>
                    </div>

                    <Form
                        name="login_form"
                        className="login-form"
                        initialValues={{ remember: true }}
                        onFinish={onFinish}
                    >
                        <Form.Item
                            name="username"
                            rules={[{ required: true, message: '请输入账号!' }]}
                        >
                            <Input
                                prefix={<UserOutlined className="site-form-item-icon" />}
                                placeholder="账号"
                                size="large"
                                className="login-input"
                            />
                        </Form.Item>
                        <Form.Item
                            name="password"
                            rules={[{ required: true, message: '请输入密码!' }]}
                        >
                            <Input.Password
                                prefix={<LockOutlined className="site-form-item-icon" />}
                                placeholder="密码"
                                size="large"
                                className="login-input"
                            />
                        </Form.Item>

                        <div className="login-agreement">
                            登录视为您已阅读并同意<a href="#">用户协议</a>和<a href="#">隐私政策</a>
                        </div>

                        <Form.Item>
                            <Button type="primary" htmlType="submit" className="login-button" loading={loading}>
                                登录
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>
    );
};

export default Login;
